import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { ConfigService } from "../../shared/services/config/config.service";

@Injectable({
  providedIn: "root",
})
export class NonProductionGuard implements CanActivate {
  constructor(
    private configService: ConfigService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const isProduction = this.configService.getConfigProperty("production");

    if (isProduction) {
      // Redirect to dashboard if trying to access in production
      this.router.navigate(["/dashboard"]);
      return false;
    }

    return true;
  }
}
